import {
  CREATE_ORDER_API_REQUEST,
  CREATE_ORDER_API_SUCCESS,
  CREATE_ORDER_API_ERROR,
  CREATE_ORDER_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function createOrderApiRequest() {
  return {
    type: CREATE_ORDER_API_REQUEST,
    payload: true,
  };
}

function createOrderApiSuccess(cart, params) {
  return {
    type: CREATE_ORDER_API_SUCCESS,
    payload: cart,
    params,
  };
}

function createOrderApiError(err) {
  return {
    type: CREATE_ORDER_API_ERROR,
    payload: err,
  };
}

function createOrderSuccess(params) {
  return {
    type: CREATE_ORDER_SUCCESS,
    payload: params,
    params,
  };
}

export function createOrderAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    const { isAuthenticated } = state.auth;
    // if (!isAuthenticated) {
    //   return dispatch(createOrderSuccess(params));
    // }
    dispatch(createOrderApiRequest());
    return cartApi
      .createOrder(state, params)
      .then(data => {
        dispatch(createOrderApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(createOrderApiError(error));
        throw error;
      });
  };
}

export default { createOrderAction };
